import { Col, Row } from 'antd'
import Drawer from 'components/Drawer'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const RowContainer = styled(Row)`
  padding: 10px;
  gap: 16px;
`
export const ColContainer = styled(Col)`
  padding: 10px;
  border: 2px solid ${COLORS.BORDER};
  border-radius: 5px;
`
export const BoldHeading = styled.div`
  font-weight: 800;
  color: ${COLORS.GREY_T_30};
  font-size: 1.2rem;
  margin-bottom: 1.6rem;
  padding: 0.6rem;
`
export const BarContainer = styled(ColContainer)`
  background-color: ${COLORS.PRIMARY_GREY_T_98};
`
